module.exports = __webpack_public_path__ + "img/About_10.852b72c5.png";